<script setup lang="ts">
import { type NumberFieldProps, useNumberField } from "@formwerk/core";

const props = defineProps<NumberFieldProps>();
const { inputProps, labelProps, errorMessage, descriptionProps, errorMessageProps, isTouched, setValue, fieldValue } = useNumberField({ ...props, min: 1, max: 5, step: 1, value: 5 });
</script>

<template>
  <div class="field" :class="{ 'is-touched': isTouched }">
    <label v-bind="labelProps">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <input v-bind="inputProps" type="hidden">
    <div class="flex items-center gap-0.5">
      <span v-for="i in 5" :key="i" class="i-local-star size-6 cursor-pointer" :class="i <= fieldValue ? 'text-primary':'text-light'" @click="setValue(i)" />
    </div>
    <div v-if="description" v-bind="descriptionProps" class="hint">
      {{ description }}
    </div>
    <div v-if="errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
  </div>
</template>
